import React, {Component} from 'react';
import {observer} from 'mobx-react';
import intl from 'react-intl-universal';
import Mousetrap from 'mousetrap';
import Button from '../../components/Button/index';
import * as SurveyJS from "survey-react";

@observer
class Survey extends Component {
    constructor(props) {
        super(props);
        this.submitHandler = this.submitHandler.bind(this);
        SurveyJS.StylesManager.applyTheme("bootstrapmaterial");
    }

    exitModal = () => {
        this.props.history.push('/');
        this.props.appStore.tracking.click('Closed Survey Modal');
    };
    onFocus = (el) => {
        let element = document.getElementById(el);
        if (!element.classList.contains('mousetrap')) {
            element.classList.add('mousetrap');
        }
    };
    componentDidMount = () => {
        Mousetrap.bind(['escape'], this.exitModal);
        this.props.appStore.tracking.pageview('Survey');
    };
    componentWillUnmount = () => {
        Mousetrap.unbind(['escape'], this.exitModal);
    };
    submitHandler = (form) => {
        this.props.appStore.submitData(form.data, (responseVal)=>{
            if(responseVal){
                this.props.history.push('/end');
            }else{
                this.props.history.push('/error');
            }
        });

    };
    ErrorListTemplate = (props) => {
        const {errors} = props;
        return (
            <div>
                {errors.map((error, i) => {
                    return (
                        <li key={i}>
                            {error.message}
                        </li>
                    );
                })}
            </div>
        );
    };

    focusFirst = el => {
        if (el && this.props.appStore.standalone) {
            setTimeout(() => {
                el.survey.focusFirstQuestion();
            }, 300);
        }
    };

    valueChanged = () => {
        this.props.appStore.setSurveyStarted();
    };

    getLang=()=>{
        const {appStore} = this.props;
        if(!appStore.meta.type.lang) return "";
        if(appStore.meta.type.lang === 'es-ES'){
            return "es";
        }if(appStore.meta.type.lang === 'zh-CN'){
            return "zh-cn";
        }if(appStore.meta.type.lang === 'it-IT'){
            return "it";
        }
        return "";
    };


    render() {
        const {appStore} = this.props;
        const surveySchema = appStore.buildSurveySchema();
        const surveyModel = new SurveyJS.Model(surveySchema);

        if (this.props.appStore.appConfig.survey && this.props.appStore.appConfig.survey.length > 0) {
            return (
                <div className={(this.props.appStore.isMobile) ? "Survey mobile" : "Survey desktop"}>
                    <div className="content">
                        <div className={"container"}>
                            {/*<iframe src="https://www.surveygizmo.com/s3/4722589/CoMap-embed-test"/>*/}
                            <link rel="stylesheet"
                                  href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0-beta.3/css/bootstrap.min.css"
                                  integrity="sha384-Zug+QiDoJOrZ5t4lssLdxGhVrurbmBWopoEl+M6BdEfwnCJZtKxi1KgxUyJq13dy"
                                  crossOrigin="anonymous"/>

                            <Button className='closeButton' aria-label="Close button" onClick={this.exitModal}>
                                <i className="fa fa-times" aria-hidden="true"/>
                            </Button>

                            <h1>{this.props.appStore.appConfig.content.demographics.headline}</h1>
                            <p>{this.props.appStore.appConfig.content.demographics.description}</p>

                            {!this.props.appStore.mapDataSubmitted &&
                            <SurveyJS.Survey
                                ref={el => this.focusFirst(el)}
                                key={surveySchema.id}
                                model={surveyModel}
                                onComplete={this.submitHandler}
                                onValueChanged={this.valueChanged}
                                locale={this.getLang()}
                            />}

                            {this.props.appStore.mapDataSubmitted &&
                            <div className="loading_container">
                                <p>{intl.get("Survey.submitting")}</p>
                                <img className="loading_spinner" src="imgs/loading.gif" alt="Loading..."/>
                            </div>
                            }
                        </div>
                    </div>

                </div>
            );
        } else {
            return (<div></div>);
        }

    }
}

export default Survey;



// WEBPACK FOOTER //
// ./src/scenes/Survey/index.js